import Toast from './ToastFactory'

export default Toast



// WEBPACK FOOTER //
// ./src/app/components/common/toasts/index.js